<template>
  <div class="dept-page">
    <a-card>
      <div class="dept-layout">
        <!-- 右侧内容区 -->
        <div class="main-content">
          <div class="dept-title">部门管理</div>
          <div class="dept-search-bar">
            <a-form layout="inline">
              <a-form-item label="部门名称">
                <a-input placeholder="请输入部门名称" style="width:180px;" />
              </a-form-item>
              <a-form-item>
                <a-button type="primary" style="margin-right:8px;">搜索</a-button>
                <a-button>重置</a-button>
              </a-form-item>
            </a-form>
          </div>
          <div class="dept-table-bar" style="text-align:right;margin-bottom:8px;">
            <a-button type="primary">新增</a-button>
          </div>
          <a-table :columns="columns" :data-source="dataSource" :pagination="false" size="middle">
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'status'">
                <a-button type="primary" size="small">启用</a-button>
              </template>
              <template v-if="column.key === 'action'">
                <a style="color:#1677ff;">编辑</a>
              </template>
            </template>
          </a-table>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import SystemSideMenu from '@/components/SystemSideMenu.vue'

const columns = [
  { title: '部门名称', dataIndex: 'name', key: 'name' },
  { title: '排序', dataIndex: 'order', key: 'order' },
  { title: '描述', dataIndex: 'desc', key: 'desc' },
  { title: '状态', dataIndex: 'status', key: 'status' },
  { title: '操作', key: 'action' }
]
const dataSource = [
  { name: '研发中心', order: 1, desc: '', status: '启用' }
]
</script>

<style lang="less" scoped>
.dept-page {
  padding: 24px;
  background: #f5f7f9;
  min-height: 100vh;
  .dept-layout {
    display: flex;
    .side-menu {
      width: 220px;
      background: #f8fafb;
      border-radius: 4px;
      margin-right: 16px;
      padding: 16px 0;
      min-height: 600px;
    }
    .main-content {
      flex: 1;
      background: #fff;
      border-radius: 4px;
      padding: 24px;
      .dept-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 12px;
      }
      .dept-search-bar {
        margin-bottom: 12px;
      }
    }
  }
}
</style> 